/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getPlaygroundAgents } from '../fn/playground/get-playground-agents';
import { GetPlaygroundAgents$Params } from '../fn/playground/get-playground-agents';
import { PlaygroundAgentsResponse } from '../models/playground-agents-response';
import { updatePlaygroundAgents } from '../fn/playground/update-playground-agents';
import { UpdatePlaygroundAgents$Params } from '../fn/playground/update-playground-agents';

@Injectable({ providedIn: 'root' })
export class PlaygroundService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPlaygroundAgents()` */
  static readonly GetPlaygroundAgentsPath = '/playground/agents';

  /**
   * Get Agents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPlaygroundAgents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlaygroundAgents$Response(params?: GetPlaygroundAgents$Params, context?: HttpContext): Observable<StrictHttpResponse<PlaygroundAgentsResponse>> {
    return getPlaygroundAgents(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Agents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPlaygroundAgents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlaygroundAgents(params?: GetPlaygroundAgents$Params, context?: HttpContext): Observable<PlaygroundAgentsResponse> {
    return this.getPlaygroundAgents$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlaygroundAgentsResponse>): PlaygroundAgentsResponse => r.body)
    );
  }

  /** Path part for operation `updatePlaygroundAgents()` */
  static readonly UpdatePlaygroundAgentsPath = '/playground/agents';

  /**
   * Update Agents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePlaygroundAgents()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePlaygroundAgents$Response(params: UpdatePlaygroundAgents$Params, context?: HttpContext): Observable<StrictHttpResponse<PlaygroundAgentsResponse>> {
    return updatePlaygroundAgents(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Agents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePlaygroundAgents$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePlaygroundAgents(params: UpdatePlaygroundAgents$Params, context?: HttpContext): Observable<PlaygroundAgentsResponse> {
    return this.updatePlaygroundAgents$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlaygroundAgentsResponse>): PlaygroundAgentsResponse => r.body)
    );
  }

}
